export default {
  ApiErrors: {
    generic: 'Si è verificato un errore. Si prega di ricaricare la pagina e contattarci se il problema persiste.',
    'Email already exists': 'E-mail non disponibile',
    'This field is required.': 'Questo campo è obbligatorio',
    'First_name must be filled': 'Il nome deve essere compilato',
    'Password length must be over 8 characters': 'La lunghezza della password deve essere di almeno 8 caratteri',
    'Unable to login with the provided credentials': 'Impossibile accedere con le credenziali fornite',
    'godson is already a customer': 'Questo e-mail appartiene già a un cliente',
    'godson is in referral process': 'Questo e-mail è già in fase di sponsorizzazione',
    'Enter a valid email address': 'Questo non è un indirizzo e-mail valido',
    'Email already in db': 'E-mail non disponibile',
    'Not an email': 'E-mail non valida',
    'Reward is soldout': 'Questo premio è esaurito',
    'Reward can only be claimed once': 'Hai già richiesto questo premio',
    'Reward is no longer valid': 'Questo premio non è più valido',
    'Not enough points': 'Non hai abbastanza punti',
    'Account already in use': 'Questo account è già utilizzato da un altro utente',
    'This instagram account does not exist on Instagram': 'Questo account Instagram non esiste',
    'social error': "Per favore inserisci il tuo account {'@'}mio_account",
    'required field': 'Si prega di completare questo campo',
    'value error': 'Il valore inserito non è corretto',
    'You already applied a discount code': 'Hai già applicato un codice sconto'
  },
  Error: {
    generic: 'Si è verificato un errore, si prega di ricaricare la pagina.',
    link: 'Ricaricare la pagina',
    title: 'Loyoly - Ops! Errore',
    blacklistMessage1: 'No eres elegible para el programa de fidelidad.',
    blacklistMessage2: 'Contacta al equipo de soporte si crees que esto es un error.'
  },
  FormEmail: {
    example: "johndoe{'@'}gmail.com",
    errors: {
      email: 'Si prega di inserire un indirizzo e-mail valido',
      emailEmpty: 'Si prega di inserire il proprio indirizzo e-mail'
    }
  },
  InApp: {
    message: "Per un'esperienza ottimale, visita il tuo browser predefinito"
  },
  Phone: {
    countrySelector: {
      placeholder: 'Prefisso del paese',
      error: 'Seleziona un paese',
      searchPlaceholder: 'Seleziona un paese'
    },
    phoneInput: {
      placeholder: 'Numero di telefono',
      example: 'Esempio:'
    },
    error: {
      invalid: 'Si prega di inserire un numero di telefono valido'
    }
  },
  Instagram: {
    ModalNotLinked: {
      title: 'Connessione al mio account Instagram',
      subtitle: 'Come funziona',
      description:
        'Si prega di inserire il proprio account Instagram e assicurarsi che sia pubblico prima di eseguire le missioni.',
      form: {
        username: 'Account Instagram',
        usernameExample: "{'@'}johndoe"
      },
      errors: {
        usernameEmpty: 'Si prega di inserire il nome del proprio account',
        usernameNotFound: 'Si prega di inserire un nome account valido'
      },
      button: 'Confermare'
    },
    ModalSearching: {
      title: 'Stiamo cercando il tuo account'
    },
    ModalLinked: {
      title: 'Connessione al mio account Instagram',
      private: {
        subtitle: 'Connessione con il tuo account impossibile',
        description: {
          title: 'Il tuo account Instagram è privato',
          text: 'Sembra che il tuo account Instagram sia privato. Passalo a pubblico per accedere a tutte le missioni.'
        }
      },
      public: {
        subtitle: 'Connessione con il tuo account riuscita',
        description: {
          title: 'Congratulazioni',
          text: 'Ora puoi eseguire le missioni.'
        }
      },
      buttons: {
        edit: 'Modifica il mio account',
        retry: 'Riprova',
        goback: 'Torna alla pagina',
        gotoChallenge: 'Vai alla missione'
      }
    },
    ModalNotFound: {
      title: 'Connessione al mio account Instagram',
      subtitle: 'Connessione con il tuo account impossibile',
      description: {
        title: 'Account non trovato',
        text: 'Ti invitiamo a cambiare account o a fare una richiesta di supporto.'
      },
      buttons: {
        change: 'Cambia account',
        retry: 'Riprova'
      }
    }
  },
  Modal: {
    Notifications: {
      title: 'Notifiche e-mail',
      information: {
        title: 'Informazioni',
        text: "Se non desideri ricevere promemoria di missioni, novità o promemoria di premi, puoi annullare l'iscrizione disattivando le caselle di seguito:"
      },
      communication: {
        optinTransactional: 'Promozionale: informazioni sul programma, livelli VIP, premi.',
        optinMarketing: 'Informativo: informazioni su acquisti e sponsorizzazioni.'
      }
    },
    SocialAccount: {
      Info: {
        public: 'Account pubblico',
        private: 'Account privato',
        followers: '<span class="weglot-ignore">{n}</span> follower | <span class="weglot-ignore">{n}</span> followers'
      }
    }
  },
  Points: '<span class="weglot-ignore">{n}</span> punto | <span class="weglot-ignore">{n}</span> punti',
  PointsDecimal: '<span class="weglot-ignore">{value}</span> punto | <span class="weglot-ignore">{value}</span> punti',
  SectionHeader: {
    poweredBy: 'Supportato da'
  },
  SectionChallenges: {
    empty: 'Non ci sono missioni disponibili nel tuo programma fedeltà',
    showAll: 'Mostra tutto',
    ModalMissionDetail: {
      description: 'Descrizione',
      pointsToEarn: 'Punti da guadagnare',
      howto: 'Come funziona?',
      uploadMedia: 'Carica il tuo media',
      reviewApplication: 'Lascia una recensione',
      linkApplication: "Scarica l'applicazione",
      newsletterPartners:
        'Cliccando su “Convalida la missione”, accetti di ricevere offerte commerciali dall’azienda tramite e-mail.',
      phonePartners: 'Accetto che il mio numero di telefono venga utilizzato per ricevere offerte via SMS.',
      clue: 'Indizio',
      linkPage: 'Vedi la pagina',
      instaMention: 'Identifica',
      tiktokMention: 'Identifica',
      instaHashtags: 'Hashtag da utilizzare',
      tiktokHashtags: 'Hashtag da utilizzare',
      linkToShare: 'Link da mettere nella tua storia',
      linkShare: 'Link da condividere',
      vouchertoShare: 'Codice promozionale da condividere',
      goToAccount: 'Vai all’account',
      goToInsta: 'Vai all’account',
      goToInstaPost: 'Vai al post Instagram',
      goToInstaReel: 'Vai al reel Instagram',
      goToInstaIGTV: 'Vai all’IGTV Instagram',
      goToTweeterTweet: 'Vai al tweet',
      goToReview: 'Lascia una recensione',
      goToShop: 'Vai al negozio',
      goToLink: 'Vai alla pagina',
      goToTypeform: 'Compila il modulo',
      goToWhatsapp: 'Unisciti al gruppo',
      submit: 'Convalida la missione',
      missionPendingTitle: 'Missione in fase di verifica',
      missionPendingExplain: 'I tuoi punti saranno accreditati a breve.',
      actionSurveyTextError: 'Si prega di selezionare una risposta',
      actionEmailError: 'Il tuo e-mail non è valido',
      actionInputError: 'Questo campo non è valido',
      actionInputImageError: 'Si prega di caricare il tuo media',
      handlingMedia: 'Elaborazione del media',
      errorMediaHandle: 'Si è verificato un errore durante l’elaborazione del tuo media',
      imageInvalid: 'Si è verificato un errore durante l’elaborazione del tuo media',
      videoSize: 'La dimensione del tuo video deve essere inferiore a 100 MB.',
      errorInstaReel: "L'URL del tuo reel non è corretto",
      'This url is not a valid google url': "L'URL della tua recensione Google non è valida",
      'This url is not a valid reel url': "L'URL del tuo reel non è corretta",
      refusalReasonCondition: 'Non rispetto delle condizioni',
      refusalReasonQuality: 'Qualità troppo bassa',
      refusalReasonContent: 'Contenuto inappropriato',
      refusalReasonSound: 'Audio inudibile',
      missionInvalidTitle: 'Missione non valida',
      missionInvalidDescription: 'Puoi ripetere la missione rispettando attentamente le regole richieste',
      missionInvalidReasons: 'Motivo del rifiuto:',
      condition: 'Condizioni',
      conditionExplanation: 'Avere più di',
      ineligible: 'Non idoneo',
      ineligibleExplanation:
        'Sembra che tu non abbia il numero richiesto di follower. Se hai più follower, ti invitiamo ad aggiornare i dati del tuo account.',
      lastUpdate: 'Ultimo aggiornamento il',
      updateAccount: 'Aggiorna il mio account',
      reviewLastPurchase: 'Lascia una recensione sul prodotto del tuo ultimo acquisto',
      whenReviewValidated:
        'Una volta che la recensione sarà convalidata, la tua missione sarà convalidata automaticamente',
      pointsToEarnPhoto: 'Punti extra se foto',
      pointsToEarnVideo: 'Punti extra se video',
      howtoBirthdate: 'Inserisci la tua data di nascita',
      errorInvalidDate: 'Si prega di inserire una data valida',
      inputMedia: 'Carica il tuo media',
      inputMediaLoaded: 'Il tuo media è stato caricato correttamente',
      placeholderAnswer: 'Scrivi la tua risposta qui',
      misteryAnswer: 'Qual è la parola misteriosa?',
      newsletterEmail: 'Conferma il tuo indirizzo e-mail',
      birthDate: 'Data di nascita',
      example: 'Esempio',
      goToChallenge: 'Vai alla missione'
    },
    ModalMissionImageRights: {
      imageRights:
        "Selezionando questa casella, confermo di essere l'autore del contenuto, accetto espressamente di cedere i diritti di proprietà intellettuale ad esso associati e autorizzo l'utilizzo della mia immagine da parte del marchio per scopi commerciali secondo i termini e le condizioni specificati in ",
      imageRightsLink: 'questo accordo.',
      title:
        'Accordo di cessione dei diritti di proprietà intellettuale sul contenuto e autorizzazione all’utilizzo dei miei attributi della personalità.',
      content:
        'Accetto espressamente che la pubblicazione del contenuto realizzato nell’ambito della mia missione (il “Contenuto”):',
      bullet1:
        'comporta la cessione, a favore del marchio, di tutti i diritti d’autore relativi, per tutto il mondo, per l’intera durata legale della protezione del diritto d’autore, a titolo esclusivo e definitivo. Riconosco che tale cessione è concessa in cambio dei punti guadagnati nell’ambito della mia missione, che ne costituiscono il giusto corrispettivo. Questa cessione include il diritto del marchio di riprodurre e rappresentare il Contenuto, in tutto o in parte, su qualsiasi supporto e con qualsiasi mezzo, esistente o futuro, prevedibile o imprevedibile, nonché il diritto di tradurre, modificare, adattare, correggere e/o rielaborare il Contenuto, da parte del marchio stesso, da solo o in collaborazione con terzi. Mi impegno affinché tale Contenuto non violi i diritti di terzi né costituisca contraffazione, garantendo il marchio a tal riguardo;',
      bullet2:
        'comporta l’autorizzazione concessa al marchio, a titolo gratuito, a fissare, riprodurre, diffondere e comunicare al pubblico gli attributi della mia personalità associati al Contenuto, su qualsiasi supporto e con qualsiasi mezzo, conosciuto o sconosciuto, prevedibile o imprevedibile, tramite qualsiasi media, rete e canale di diffusione, a fini di sfruttamento, informazione, comunicazione, promozione e pubblicità dei prodotti del marchio, per un periodo di 10 anni, prorogabile previo accordo reciproco.',
      end1: 'Il presente accordo è regolato dalla legge francese e sarà interpretato secondo tale legge.',
      end2: 'Ogni controversia relativa alla validità, interpretazione o esecuzione dell’accordo sarà sottoposta alla competenza esclusiva dei Tribunali di Parigi, salvo diversa disposizione procedurale.'
    },
    ModalMissionLoyaltyDetail: {
      pointsToEarn:
        'Guadagnerai <span class="weglot-ignore">{points}</span> punti per ogni <span class="weglot-ignore">{amountToPoints}</span> speso | <span class="weglot-ignore">{points}</span> punti da guadagnare per ogni <span class="weglot-ignore">{amountToPoints}</span> spesi',
      orderNumber: 'Numero ordine',
      orderDate: 'Data',
      orderAmount: 'Importo',
      orderRewardable: 'Premiabile',
      orderPoints: 'Punti guadagnati',
      orderPaid: 'Validato',
      orderStatus: 'Stato',
      orderCancel: 'Rimborsato',
      orderRefund: 'Parzialmente rimborsato',
      orderWaiting: 'In attesa'
    },
    CompanyConditions: {
      seeTermsAndConditions: 'Visualizza le condizioni',
      seePrivacy: 'Visualizza la privacy'
    }
  },
  SectionProfile: {
    socialNetworks: {
      instagram: 'Connessione a Instagram',
      tiktok: 'Connessione a TikTok'
    },
    notificationsByEmails: 'Notifiche via e-mail',
    cgu: 'Termini e condizioni generali'
  },
  SectionAccountRewards: {
    empty: 'Non ci sono più ricompense da scambiare e non hai ricompense in attesa di essere utilizzate',
    copied: 'Copiato!'
  },
  SectionRewards: {
    empty: 'Non ci sono premi disponibili nel tuo programma fedeltà',
    showAll: 'Mostra tutto',
    Card: {
      channel_store: 'In negozio',
      channel_online: 'Online',
      channel_both: 'Online e in negozio'
    }
  },
  SectionRewardsModalMyRewards: {
    title: 'I miei premi',
    empty: 'Non hai ancora nessun premio.',
    emptyTip: 'Puoi fare missioni e scambiare i punti guadagnati con premi',
    use: 'Usa',
    expired: 'Scaduta'
  },
  SectionRewardsDetailInfos: {
    expireDate: 'Data di scadenza',
    expirationDelayExplain:
      'Il premio sarà utilizzabile per <span class="weglot-ignore">{expiration_delay}</span> giorni una volta scambiato.',
    minimumBuy: 'Acquisto minimo',
    maxAmount: 'Valido fino a',
    description: 'Descrizione',
    saleChannel: 'Canale di vendita',
    channelStore: 'In negozio',
    channelOnline: 'Online',
    channelBoth: 'Online e in negozio'
  },
  SectionRewardsDetailModal: {
    exchange: 'Scambia',
    errorMessage1: 'Sembra che si sia verificato un problema.',
    errorMessage2: 'La tua ricompensa non è stata scambiata e i tuoi punti non sono stati detratti.',
    errorMessage3: 'Per favore, ricarica la pagina.',
    errorButton: 'Ricarica la pagina'
  },
  SectionRewardsClaimModal: {
    howItWorks: 'Come funziona?',
    howItWorkCode: 'Usa il tuo codice sul nostro sito web durante il tuo ordine',
    howItWorkCodeProduct: 'Aggiungi il prodotto al carrello e usa il tuo codice durante l’ordine',
    howItWorkCodeRecharge: 'Aggiungi il codice direttamente nel tuo portale clienti',
    howItWorkExt: 'Sarai contattato per ottenere il tuo premio',
    applyToBasket: 'Applica al carrello',
    apply: 'Applica',
    applied: 'Applicato',
    link: 'Link al prodotto',
    copied: 'Copiato!',
    customerPortal: 'Portale clienti',
    nonApplicable: 'Non idoneo'
  },
  SectionRewardsDetailsRechargeSubscriptions: {
    apply: 'Applica',
    nonApplicable: 'Non idoneo',
    itemTitle: '{title} / {price}',
    customerPortal: 'Portale clienti'
  },
  SectionReferral: {
    friendEmail: 'E-mail del tuo amico',
    seeReferral: 'Vedi i miei riferimenti',
    errors: {
      emailSelf: "L'e-mail inserita è identica al tuo e-mail"
    },
    Tabs: {
      link: 'Link',
      email: 'E-mail',
      sms: 'SMS',
      copy: 'Copia link',
      smsSend: 'Invia un messaggio',
      reward1: '{amount} punti',
      reward2: '{amount}% di sconto',
      reward3: 'Buono di {amount}',
      smsTemplate:
        "Ciao! Ho scoperto {brand_name} che potrebbe piacerti.\n\n Utilizzando il mio link di referenza {referral_link}, potrai beneficiare di {reward_friend}.\n\nApprofittane, è un'offerta davvero interessante!\nA presto!"
    },
    Modal: {
      emptyState: 'Non hai ancora effettuato alcun riferimento',
      title: 'I miei riferimenti',
      status: 'Stato',
      email: 'E-mail',
      date: 'Data di scadenza',
      statusPending: 'In attesa',
      statusUsed: 'Già utilizzato',
      statusAvailable: 'Disponibile',
      statusExpired: 'Scaduto',
      statusInvalidate: 'Invalidato',
      promocodeComing: 'In arrivo',
      promocodeUnavailable: '-',
      promocodeInvalidate: 'Invalidato',
      points_given: 'I tuoi punti sono stati accreditati',
      referral_type_3: "Buono d'acquisto",
      referral_type_2: 'Codice promozionale',
      referral_type_1: 'Punti'
    },
    NotAuthenticatedForm: {
      emailPlaceholder: 'E-mail',
      emailError: 'Il formato dell’e-mail non è corretto',
      emailEmpty: 'Si prega di compilare questo campo',
      emailUnknown: 'Si prega di creare un account per poter fare riferimento'
    }
  },
  SectionVipTiersProgress: {
    you: 'Tu',
    points: 'punti'
  },
  SectionVipTiersCard: {
    rewardPoints: '{points} punti offerti',
    rewardMultiplier: 'Moltiplicatore di punti: x{multiplier}',

    tiersPoints: '{amount} punti'
  },
  SectionGifting: {
    empty: 'Non ci sono test di prodotto disponibili al momento',
    showAll: 'Mostra tutto',
    ModalApply: {
      endDate: 'Data di fine delle candidature',
      description: 'Descrizione',
      completeForm: 'Compila il modulo per inviare la tua candidatura',
      button: 'Candidati',
      success: {
        title: 'Iscrizione al test del prodotto',
        description:
          'Grazie per aver completato le informazioni. La tua candidatura è in fase di revisione. Sarai avvisato via e-mail.'
      },
      Form: {
        Errors: {
          required: 'Si prega di completare questo campo',
          date: 'Si prega di inserire una data valida'
        }
      }
    },
    ModalParticipate: {
      challenges: 'Missioni',
      howItWorks: 'Come funziona?',
      useCode: 'Usa il tuo codice sul nostro sito web durante l’ordine.',
      youWillBeContacted: 'Sarai contattato per ricevere il tuo prodotto.',
      buttonLink: 'Link al prodotto',
      buttonCopied: 'Copiato!'
    }
  },
  SectionGiftingCardList: {
    status: {
      participate: 'Partecipa',
      underValidation: 'In fase di validazione',
      apply: 'Candidati',
      ended: 'Terminato',
      rejected: 'Candidatura non accettata'
    }
  },
  SectionSteps: {
    Authenticated: {
      month: '{n} mese| {n} mesi'
    },
    ModalActivities: {
      title: 'Le mie attività recenti',
      empty: 'Non hai ancora attività recenti.',
      table: {
        header: {
          title: 'Titolo',
          points: 'Punti',
          date: 'Data'
        }
      },
      events: {
        challenge: 'Missione convalidata',
        order: 'Acquisto effettuato',
        reward: 'Premio ottenuto',
        refferal: 'Referenza convalidata',
        userAction: 'Punti regolati',
        level: 'Livello raggiunto',
        levelLabel: 'Livello {level}',
        reset: 'Scadenza dei punti',
        automation: 'Punti guadagnati'
      }
    }
  },
  Tiktok: {
    ModalNotLinked: {
      title: 'Connessione al mio account TikTok',
      subtitle: 'Come funziona',
      description:
        'Si prega di inserire il proprio account TikTok assicurandosi che sia pubblico. Potrai quindi eseguire le missioni TikTok.',
      button: 'Collega il mio account'
    },
    ModalLinked: {
      title: 'Connessione al mio account TikTok',
      subtitle: 'Connessione con il tuo account riuscita',
      congratulations: 'Congratulazioni',
      description: 'Ora puoi eseguire le missioni.',
      buttons: {
        edit: 'Modifica il mio account',
        goback: 'Torna alla pagina'
      }
    }
  },
  SectionReferralFriend: {
    placeholder: 'Indirizzo e-mail',
    emailError: 'Si prega di inserire un indirizzo e-mail valido',
    emailEmpty: 'Si prega di inserire il proprio indirizzo e-mail',
    disclaimer: 'Questa offerta è valida solo per i nuovi clienti',
    disclaimerVerification: 'Non sarai ricontattato a fini commerciali.',
    referral_type_3: 'Buono',
    referral_type_2: 'Codice promozionale',
    referral_type_1: 'Punti',
    copied: 'Copiato!',
    label_optin_reminder: 'Desidero ricevere un promemoria se non utilizzo il mio sconto.',
    btn_optin_reminder: 'Ricevi un promemoria per il mio codice'
  },
  Unsubscribe: {
    title: "Vuoi davvero annullare l'iscrizione alle email del nostro programma fedeltà?",
    description: 'Se lo fai, sappi che non riceverai più informazioni riguardanti le tue ricompense, missioni e punti.',
    email: 'E-mail',
    button: 'Aggiorna le mie preferenze',
    question: 'Che tipo di email desideri ricevere?',
    optinTransactional: 'Promozionale: informazioni sul programma, livelli VIP, premi.',
    optinMarketing: 'Informativo: informazioni su acquisti e sponsorizzazioni.',
    successTitle: 'Le tue preferenze sono state aggiornate',
    successDescription: 'Usa il pulsante qui sotto per rivedere o modificare le tue preferenze',
    successButton: 'Aggiorna le mie preferenze',
    errorTitle: "C'è un errore con il link di reindirizzamento",
    errorButton: 'Reindirizza al sito web'
  },
  SectionAccount: {
    copied: 'Copiato!'
  },
  SectionPointCard: {
    you: 'Tu',
    copied: 'Copiato!'
  }
}
